<template>
  <v-toolbar
    flat
    dense
    max-height="48"
    color="grey lighten-4"
  >
    <h-list-filter filter="table" />
    <h-range-filter filter="guests" min="1" max="30" />
    <h-list-filter filter="user" title="waiter" />
    <h-time-filter filter="opened" icon="clockIn" title="timeFrom" />
    <h-time-filter filter="closed" icon="clockOut" title="timeUntil" />
    <h-range-filter filter="amount" icon="coins" max="500" step="10" />
  </v-toolbar>
</template>

<script>
  import HListFilter from './Filters/List'
  import HRangeFilter from './Filters/Range'
  import HTimeFilter from './Filters/Time'

  export default {
    components: {
      HListFilter,
      HRangeFilter,
      HTimeFilter,
    },
  }
</script>
